import React, {useRef, useEffect, useState} from 'react'
import styled from 'styled-components'
import mapSVG from '../assets/compass.svg'
import BlackDiv from './ui/BlackDiv'
import H1 from './ui/H1'
import groupPicture from '../assets/photos/54278854_2001027003348352_16178587753250816_o.jpg'

const Section = styled.section`
display:grid;
grid-template-columns:1fr 1fr;
grid-auto-rows:max-content;
gap:1rem;
box-sizing:border-box;
width:100%;
overflow-x:hidden;
padding:1rem;
text-align:left;
color:rgb(30,30,30);

& h2{
    text-align:center;
}
& p{
    line-height:1.5rem;
    padding:1rem;
}
@media only screen and (max-width:600px){
    & h2{
        text-align:center;
    }
    & >*{
        grid-column:span 2;
    }
}

`
const P = styled.p`
border-left:1px solid grey;
padding-left:1rem;
@media only screen and (max-width:600px){
   border:none;
}

`;

const MapSkeleton = styled.div`
    width:100%;
    height:300px;
    background:white;
`


const Button = styled.button`
font-family:inherit;
font-size:1rem;
padding:1rem 2rem;
border:none;
margin-top:-2.2rem;
background:rgb(150,20,20);
color:white;
cursor:pointer;
transition:0.2s;
margin:0 auto;
display:block;
z-index:10;
&:hover{
opacity:0.6;
}
& a{
color:white;
text-decoration:none;
}

`

const skeleton = {
    background:'white',
    height:'300px',
    margin:'auto',
    marginTop:'5%',
    width:'90%',
    animation:'skeleton 2s infinite ease-in-out'
}


export default ()=>{

    const [mounted, setMount] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [scrolled, setScrolled] = useState(false)

    const mapContainer = useRef(null);

    function isItVisible(){
        if(document.getElementById('about-us').getBoundingClientRect().top < window.scrollY){
            setScrolled(true)
        }
    }

    useEffect(() => {  
        isItVisible()
        setMount(true)
        window.addEventListener('resize',()=>{
            document.getElementById('google-map').width = mapContainer.current?.offsetWidth - 40
        })

        document.addEventListener('scroll',e=>{
            if(window.scrollY>500 && !loaded){
                setLoaded(true)
            }
            isItVisible()
        })
    },[]);

   
    const MapComponent = (mapwidth)=>{
        if(mounted && loaded){
            return <iframe lazy id="google-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101596.12122381834!2d-80.02758253214041!3d37.27430131888424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884d0c4d6aa966fd%3A0x249dbecbdbb0989b!2sRoanoke%2C%20VA!5e0!3m2!1sen!2sus!4v1614436200481!5m2!1sen!2sus" 
            width={mapwidth} height="300" 
            style={{border:'0',paddingTop:'4rem',margin:'auto',display:'block'}} allowfullscreen="" 
            ></iframe>
        }else{
            return null
        }
    }
    
    

    return (
    <React.Fragment>
    
    <Section >
        <div id="about-us" style={{gridColumn:'span 2',transition:'0.5s',transitionDelay:"0s",
        opacity:scrolled ? 1 : 0, transform:scrolled ? 'translateX(0)' : 'translateX(2rem)'
        }}>
        <H1 >About Us</H1>
        </div>
        
            <div style={{transition:'1s',transitionDelay:"1s",
        opacity:scrolled ? 1 : 0, transform:scrolled ? 'translateX(0)' : 'translateY(2rem)'}}>
                <h2>WHO WE ARE</h2>
                <p>ECB is a group of Christian musicians who have come together to praise and worship the one true God - Jesus Christ! We perform both Traditional Gospel and Contemporary Christian with only one goal in mind - to lift him up! He is Exalted!
                ECB owns this page. ECB is a nonprofit Christian band.</p>
            </div>

            <div style={{transition:'1s',transitionDelay:"1s",
        opacity:scrolled ? 1 : 0,transform:scrolled ? 'translateX(0)' : 'translateY(2rem)'}}>
            <h2>OUR MEMBERS</h2>
            <P>
            Sheri Fullen - Vocals
            <br/>
            Rick Drewery - Rhythm Guitar, Vocals
            <br/>
            Tim Shoemaker - Bass Guitar, Vocals
            <br/>
            Rankin Darby - Drums
            <br/>
            Billy Wood - Lead Guitar, Vocals
            <br/>
            Mike Laffoon - Sound
            </P>

        </div>
            
            <div style={{transition:'1s',transitionDelay:"1.5s",
        opacity:scrolled ? 1 : 0, transform:scrolled ? 'translateY(0)' : 'translateY(-2rem)'}}>
                <h2>DONATIONS</h2>
                <p>If you would like to make a donation, feel free to use the box below.</p>

                <form style={{margin:'auto',width:'max-content'}} action="https://www.paypal.com/donate" method="post" target="_top">
                <input type="hidden" name="business" value="exalted@cox.net" />
                <input type="hidden" name="item_name" value="Exalted Ministries" />
                <input type="hidden" name="currency_code" value="USD" />
                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                </form>
            </div>
            

            

       
        
        <div style={{transition:'1s',transitionDelay:"1.5s",
        opacity:scrolled ? 1 : 0, transform:scrolled ? 'translateY(0)' : 'translateY(-2rem)'}}>
            <h2>OUR VISION</h2>
            <p>We exist to share God's love and message of Salvation through Jesus Christ.</p>
        </div>

        {/* <div style={{gridColumn:'span 2'}} >
            <img style={{width:'100%',maxWidth:'600px',display:'block',margin:'auto',marginTop:'4rem',borderRadius:'5px',boxShadow:"3px 3px 3px black"}} src={groupPicture} alt=""/>
        </div> */}
        

        <BlackDiv>
            <div ref={mapContainer}>
                {loaded? MapComponent(mapContainer.current?.offsetWidth - 40 ) : <div style={skeleton}></div>}
                <br/>
                <br/>
            </div>
            
            <div>
            <h2 style={{textAlign:'center', display:'flex',alignItems:'center', justifyContent:'center', flexWrap:"wrap"}}><img style={{width:'2rem',height:'2rem',marginRight:"1rem"}} src={mapSVG}></img><div style={{marginTop:"0.25rem"}}>WHERE WE ARE</div></h2>
            <p style={{padding:'1rem',color:'rgba(175,175,175)'}}>ECB is located in the beautiful, Blue Ridge mountains of Southwest Virginia. Based in Roanoke, VA, ECB
            performs at churches and venues across the greater Roanoke region.
          
            </p>
       
            <h3 style={{textAlign:'center',padding:'0rem 1rem'}}>Want to book us? Contact us here.</h3>
            <br/>
            <Button><a href="#contact">Contact</a></Button>
            <br/>
        </div>
        </BlackDiv>

        
    </Section>
    </React.Fragment>
)}